/**
 * TanStack Router: /performance/configuracoes
 *
 * This route file was auto-generated by the route generation script.
 * Component: PerformanceConfiguracoesPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import PerformanceConfiguracoesPage from '@/app/performance/configuracoes/page'

/**
 * Route: /performance/configuracoes
 * Layout: _auth (authenticated)
 * Component: PerformanceConfiguracoesPage
 */
export const Route = createFileRoute('/_auth/performance/configuracoes/')({
  component: PerformanceConfiguracoesPage,
})
